import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../services/api";
import { useTranslation } from "react-i18next";
import {
  Instagram,
  // Facebook,
  // Twitter,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";
import { FaTiktok } from "react-icons/fa6";
import logo from "../assets/logo.jpeg";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get("/contact-settings");
        setSettings(res.data);
      } catch (err) {
        console.error("Failed to load contact settings", err);
      }
    };
    load();
  }, []);

   if (!settings) return null;

  return (
    <footer className="bg-earth-brown text-cream">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <img
                src={logo}
                alt="Herbatica Logo"
                className="h-12 w-12 rounded-full object-cover"
              />
              <span className="text-2xl font-serif font-bold">Herbatica</span>
            </Link>
            <p className="text-cream/70 leading-relaxed">
             {t("footer.tagline")}
            </p>
            <p className="text-cream/70 leading-relaxed">
             {t("footer.since")}
            </p>
            {/* Business Hours */}
            {settings && (
              <p className="text-cream/70 leading-relaxed">
                {settings[`business_hours_${lang}`]}
              </p>
            )}
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-serif font-semibold mb-6">
                {t("footer.quickLinks")}
            </h4>
            <ul className="space-y-3">
              {[
                { name: t("nav.home"), path: "/" },
                { name: t("nav.products"), path: "/products" },
                { name: t("nav.about"), path: "/about" },
                { name: t("nav.contact"), path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-cream/70 hover:text-cream transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-serif font-semibold mb-6">
              {t("footer.contactUs")}
            </h4>
            <ul className="space-y-4">
              {settings && (
                <>
                  <li className="flex items-start gap-3">
                    <a
                      href={settings.map_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-start gap-3 text-cream/70 hover:text-cream transition-colors"
                    >
                      <MapPin
                        size={18}
                        className="text-herb-green-light mt-1"
                      />
                      <span>{settings[`address_${lang}`]}</span>
                    </a>
                  </li>

                  <li className="flex items-center gap-3">
                    <a
                      href={`tel:${settings[`phone_1_${lang}`]}`}
                      className="flex items-center gap-3 text-cream/70 hover:text-cream"
                    >
                      <Phone size={18} className="text-herb-green-light" />
                      <span>{settings[`phone_1_${lang}`]}</span>
                    </a>
                  </li>

                  <li className="flex items-center gap-3">
                    <a
                      href={`tel:${settings[`phone_2_${lang}`]}`}
                      className="flex items-center gap-3 text-cream/70 hover:text-cream"
                    >
                      <Phone size={18} className="text-herb-green-light" />
                      <span>{settings[`phone_2_${lang}`]}</span>
                    </a>
                  </li>

                  <li className="flex items-center gap-3">
                    <a
                      href={`mailto:${settings.email}`}
                       onClick={(e) => {
    if (!navigator.userAgent.includes("Mobile")) {
      e.preventDefault();
      window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${settings.email}`, "_blank");
    }
  }}
                      className="flex items-center gap-3 text-cream/70 hover:text-cream"
                    >
                      <Mail size={18} className="text-herb-green-light" />
                      <span>{settings.email}</span>
                    </a>
                  </li>
                </>
              )}
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-lg font-serif font-semibold mb-6">{t("footer.follow")}</h4>
            <div className="flex gap-4">
              {[
                {
                  icon: Instagram,
                  href: "https://www.instagram.com/herbaticalb?igsh=cmNhMzJrb3dpbHh0",
                },

                {
                  icon: FaTiktok,
                  href: "https://www.tiktok.com/@herbaticalb?_r=1&_t=ZS-92A2HGZOfmU",
                },
              ].map(({ icon: Icon, href }, index) => (
                <a
                  key={index}
                  href={href}
                  className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-herb-green-light transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
            <p className="mt-6 text-cream/50 text-sm">
               {t("footer.followText")}
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-cream/10 text-center text-cream/50 text-sm">
           © {currentYear} Herbatica. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
